import React, { useState } from 'react';
import ReportImage from './components/ReportImage';
import DownloadReport from './components/DownloadReport';
import ViewReportButton from './components/ViewReportButton';
import LoadingPopup from './components/LoadingPopup';
import ViewValueLogo from './components/ViewValueLogo';
import { CheckCircle } from 'lucide-react';

function App() {
  const [uploading, setUploading] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [imgError, setImgError] = useState(false);

  const handleConvert = () => {
    setUploading(true);
    setUploadComplete(false);
  };

  const handleComplete = () => {
    setUploading(false);
    setUploadComplete(true);
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col items-center justify-start px-6 py-10 font-sans">
      
      {/* ViewValue Logo and Subtitle */}
      <div className="mb-10 text-center">
        <ViewValueLogo size="text-3xl" iconSize={8} />
        <p className="text-sm text-gray-500 tracking-widest uppercase mt-1">Report Demo</p>
      </div>

      {/* Main Card */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl p-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">

        {/* Left: Report Image + Download */}
        <div className="flex flex-col items-center justify-start">
          {!imgError ? (
            <ReportImage onError={() => setImgError(true)} />
          ) : (
            <div className="text-red-500 text-sm bg-red-100 px-4 py-3 rounded">
              ⚠️ Could not load image.
            </div>
          )}
          <DownloadReport />
        </div>

        {/* Right: CTA, Loading, or Success */}
        <div className="flex flex-col items-center text-center w-full">
          {!uploading && !uploadComplete && (
            <>
              {/* Title + Subtitle */}
              <div className="max-w-md mx-auto text-left mb-8">
  <h2 className="text-2xl font-bold text-gray-800 leading-tight mb-4">
  Convert Papa John’s 2023 10-K into an AI-Driven Dashboard

</h2>
  <p className="text-base text-gray-600 mb-6">
  Instantly transform Papa John’s official 2023 10-K filing into a sleek, AI-powered dashboard — complete with interactive KPIs, benchmark analysis, AI analysis, and updated information.

  </p>

  {/* Feature List */}
  <div className="space-y-3 text-gray-700 text-sm">
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">AI-Powered Executive Summaries</p>
    </div>
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">Interactive Financial Benchmarks & Ratios</p>
    </div>
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">Forecasted KPIs and Trend Visualizations</p>
    </div>
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">Human-readable AI Analysis with Context</p>
    </div>
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">Shareable Client-Facing Dashboards</p>
    </div>
    <div className="flex items-start gap-2">
      <span className="text-green-500 mt-0.5">✓</span>
      <p className="leading-snug">Relevant Investor Information</p>
    </div>
  </div>
</div>


              {/* CTA Button */}
              <button
                onClick={handleConvert}
                className="bg-blue-600 text-white px-6 py-3 rounded-xl text-base font-semibold shadow-lg hover:shadow-xl hover:bg-blue-700 transition transform hover:scale-105 duration-300 w-full max-w-md mx-auto"
              >
                Convert This Report
              </button>

              {/* Disclaimer */}
  <p className="text-xs text-gray-500 text-center mt-4 max-w-md mx-auto">
    The 2023 Annual Report and Form 10-K is a public document used solely for demonstration purposes.
    This demo features only the 2023 filing. To explore additional reports, visit{" "}
    <a href="https://viewvalue.io/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-800">
      viewvalue.io
    </a>.
  </p>
            </>
          )}

          {uploading && !uploadComplete && <LoadingPopup onComplete={handleComplete} />}

          {uploadComplete && (
            <div className="flex flex-col items-center space-y-4">
              <CheckCircle className="w-8 h-8 text-green-600" />
              <p className="text-gray-700 font-medium">Your report is ready.</p>
              <ViewReportButton onClick={() => alert('Redirecting to report viewer...')} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
